'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import { useInquiryForm } from '@/app/about/_hooks/useInquiryForm';
import type { ModalTypes } from '@/app/about/_types/modalTypes';
import { useDeviceStore } from '@/store/about/deviceStore';
import SearchEstate from './SearchEstate';
export default function InquiryModal(t0) {
  const $ = _c(85);
  const {
    isOpen,
    close
  } = t0;
  const {
    deviceType
  } = useDeviceStore();
  const {
    activeItems,
    keyword,
    setKeyword,
    phoneNumber,
    formData,
    setFormData,
    handleChangeForm,
    phoneValidation,
    toggleActive,
    isButtonDisabled,
    handleSubmitInquiry
  } = useInquiryForm(close);
  let t1;
  if ($[0] !== close) {
    t1 = open => !open && close();
    $[0] = close;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = deviceType === "mobile" ? "is_mobile" : "is_desktop";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("wrap_modal dim_dark", "modal_inquiry");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="headline"><Dialog.Title className="title">원활한 상담을 위해<br />아래 정보를 입력해주세요.</Dialog.Title><Dialog.Description className="text_blind">상담문의를 위해 정보 작성해주세요.</Dialog.Description></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text_blind">닫기</span>;
    t6 = <i className="icon_close" />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== close) {
    t7 = <div className="modal_header">{t4}<Dialog.Close asChild={true}><button className="btn_close" type="button" onClick={close}>{t5}{t6}</button></Dialog.Close></div>;
    $[6] = close;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <label htmlFor="inquiryName">중개사무소 정보</label>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <i className="btn_tooltip icon_tooltip" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="title">{t8}<div className="wrap_tooltip">{t9}<div className="tooltip">중개사님의 성명 검색을 통해 국가공간정보포털 부동산중개업에 등록된 정보를 선택하세요.<br />중개사무소가 검색되지 않을 경우 [중개사무소 개업 준비중] 체크박스를 선택하거나, 1800-6950으로 문의주세요.</div></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== formData || $[12] !== keyword || $[13] !== setFormData || $[14] !== setKeyword) {
    t11 = <SearchEstate formData={formData} keyword={keyword} setFormData={setFormData} setKeyword={setKeyword} />;
    $[11] = formData;
    $[12] = keyword;
    $[13] = setFormData;
    $[14] = setKeyword;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = formData.preOpen === "Y";
  let t13;
  if ($[16] !== handleChangeForm || $[17] !== t12) {
    t13 = <input id="inquiryReady" name="preOpen" type="checkbox" checked={t12} onChange={handleChangeForm} />;
    $[16] = handleChangeForm;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <label htmlFor="inquiryReady">중개사무소 개업 준비중입니다.</label>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13) {
    t15 = <div className="wrap_check">{t13}{t14}</div>;
    $[20] = t13;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t11 || $[23] !== t15) {
    t16 = <div className="fieldset"><div className="item">{t10}{t11}{t15}</div></div>;
    $[22] = t11;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="title"><label htmlFor="inquiryPhone">휴대폰번호</label></div>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== phoneNumber || $[27] !== phoneValidation) {
    t18 = <div className="fieldset"><div className="item">{t17}<input id="inquiryPhone" name="tel" type="text" inputMode="numeric" pattern="[0-9]*" placeholder={"\uC5F0\uB77D \uBC1B\uC744 \uC218 \uC788\uB294 \uD734\uB300\uD3F0 \uBC88\uD638"} maxLength={11} value={phoneNumber} onChange={phoneValidation} autoComplete="off" /></div></div>;
    $[26] = phoneNumber;
    $[27] = phoneValidation;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== activeItems) {
    t19 = clsx("item", activeItems.includes("privacy") && "active");
    $[29] = activeItems;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="title">개인정보 제공 동의</div>;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== handleChangeForm) {
    t21 = <input id="agreePrivacy" name="isPersonalTrm" type="checkbox" onChange={handleChangeForm} />;
    $[32] = handleChangeForm;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <label htmlFor="agreePrivacy">(필수) 개인정보의 수집·이용에 동의합니다.</label>;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== deviceType || $[36] !== toggleActive) {
    t23 = deviceType === "mobile" && <button className="btn_toggle" type="button" onClick={() => toggleActive("privacy")}><i className="icon_angle" /></button>;
    $[35] = deviceType;
    $[36] = toggleActive;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t21 || $[39] !== t23) {
    t24 = <div className="wrap_check">{t21}{t22}{t23}</div>;
    $[38] = t21;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="box gray50"><h4 className="title">개인정보 수집·이용 동의</h4><p className="desc">항목 : 중개사성명, 휴대폰번호, 중개업소상호명, 중개업소소재지 / 목적 : 이실장 서비스 상담신청 / 보유·이용 기간 : 3개월</p></div>;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t19 || $[43] !== t24) {
    t26 = <div className={t19}>{t20}{t24}{t25}</div>;
    $[42] = t19;
    $[43] = t24;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== activeItems) {
    t27 = clsx("item", activeItems.includes("marketing") && "active");
    $[45] = activeItems;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== handleChangeForm) {
    t28 = <input id="agreeMarketing" name="isAdTrm" type="checkbox" onChange={handleChangeForm} />;
    $[47] = handleChangeForm;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <label htmlFor="agreeMarketing">(선택) 개인정보의 홍보·마케팅 이용에 동의합니다.</label>;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== deviceType || $[51] !== toggleActive) {
    t30 = deviceType === "mobile" && <button className="btn_toggle" type="button" onClick={() => toggleActive("marketing")}><i className="icon_angle" /></button>;
    $[50] = deviceType;
    $[51] = toggleActive;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== t28 || $[54] !== t30) {
    t31 = <div className="wrap_check">{t28}{t29}{t30}</div>;
    $[53] = t28;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  let t33;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="box gray50"><h4 className="title">홍보·마케팅 동의</h4><p className="desc">항목 : 중개사성명, 휴대폰번호, 중개업소상호명, 중개업소소재지 / 목적 : 이실장 서비스 관련 홍보·마케팅 (카카오톡 알림톡, DM, SMS, LMS, MMS 및 E-mail) / 보유·이용 기간 : 3개월</p></div>;
    t33 = <div className="refer">* 상기 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 이실장 서비스 상담 및 안내에 어려움이 있을 수 있습니다.</div>;
    $[56] = t32;
    $[57] = t33;
  } else {
    t32 = $[56];
    t33 = $[57];
  }
  let t34;
  if ($[58] !== t27 || $[59] !== t31) {
    t34 = <div className={t27}>{t31}{t32}{t33}</div>;
    $[58] = t27;
    $[59] = t31;
    $[60] = t34;
  } else {
    t34 = $[60];
  }
  let t35;
  if ($[61] !== t26 || $[62] !== t34) {
    t35 = <div className="fieldset">{t26}{t34}</div>;
    $[61] = t26;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t16 || $[65] !== t18 || $[66] !== t35) {
    t36 = <div className="group_form">{t16}{t18}{t35}</div>;
    $[64] = t16;
    $[65] = t18;
    $[66] = t35;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== handleSubmitInquiry || $[69] !== t36) {
    t37 = <div className="modal_content"><form id="inquiryForm" onSubmit={handleSubmitInquiry}>{t36}</form></div>;
    $[68] = handleSubmitInquiry;
    $[69] = t36;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== deviceType || $[72] !== isButtonDisabled) {
    t38 = <div className="modal_footer">{deviceType === "desktop" ? <button className="btn btn_rounded_primary400 xl" form="inquiryForm" type="submit" disabled={isButtonDisabled}>접수하기</button> : <button className="btn btn_square_primary400 lg" form="inquiryForm" type="submit" disabled={isButtonDisabled}>접수하기</button>}</div>;
    $[71] = deviceType;
    $[72] = isButtonDisabled;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== t37 || $[75] !== t38 || $[76] !== t7) {
    t39 = <Dialog.Overlay className={t3}><Dialog.Content className="modal">{t7}{t37}{t38}</Dialog.Content></Dialog.Overlay>;
    $[74] = t37;
    $[75] = t38;
    $[76] = t7;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] !== t2 || $[79] !== t39) {
    t40 = <Dialog.Portal><div className={t2}>{t39}</div></Dialog.Portal>;
    $[78] = t2;
    $[79] = t39;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== isOpen || $[82] !== t1 || $[83] !== t40) {
    t41 = <Dialog.Root open={isOpen} onOpenChange={t1}>{t40}</Dialog.Root>;
    $[81] = isOpen;
    $[82] = t1;
    $[83] = t40;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  return t41;
}